import { atom, selector } from "recoil"
import { STREAM_RECORD_ACTION } from "../../../constants/enums"
import { recordingAction } from "./types"

export const recordingAtom = atom<string>({
  key: "recordingAtom",
  default: null,
  dangerouslyAllowMutability: true
})

export const recordingLoaderAtom = atom<boolean>({
  key: "recordingLoaderAtom",
  default: false,
  dangerouslyAllowMutability: true
})

export const recordingUserIdAtom = atom({
  key: "recordingUserIdAtom",
  default: null,
  dangerouslyAllowMutability: true
})

export const recordingStartAtom = atom<boolean>({
  key: "recordingStartAtom ",
  default: false,
  dangerouslyAllowMutability: true
})

export const connectBotRecordingAtom = atom<boolean>({
  key: "connectBotRecordingAtom",
  default: false,
  dangerouslyAllowMutability: true
})

export const recordingSelector = selector({
  key: "recordingSelector",
  get: ({ get }) => {
    return get(recordingAtom)
  },
  set: ({ set, reset }, action) => {
    const { payload, type } = action as recordingAction

    if (type === "TOGGLE") {
      set(recordingAtom, payload.action)
    }

    if(payload.action === STREAM_RECORD_ACTION.START) {
      // add owner userId and start streaming
      set(recordingUserIdAtom, payload.userId)
      set(recordingStartAtom, true)

    } else {
      // clear the owner id and stopStreaming
      reset(recordingStartAtom)
      reset(recordingLoaderAtom)
      reset(recordingUserIdAtom)
      reset(connectBotRecordingAtom)
    }
  }
})

interface RecordingLoaderCallbackSelectorProps {
  handleReturnData?: () => Promise<boolean>
}

export const recordingLoadeCallbackSelector =
  selector<RecordingLoaderCallbackSelectorProps>({
    key: "recordingLoadeCallbackSelector",
    get: ({ getCallback }) => {
      const handleReturnData = getCallback(({ snapshot }) => async () => {
        const data = await snapshot.getPromise(recordingLoaderAtom)

        return data
      })
      return { handleReturnData }
    }
  })

export const resetAllRecordingRecoilStateSelector = selector({
  key: "resetAllRecordingRecoilStateSelector",
  get: () => {},
  set: ({ reset }) => {
    reset(recordingAtom)
    reset(recordingLoaderAtom)
    reset(recordingStartAtom)
    reset(connectBotRecordingAtom)
    reset(recordingUserIdAtom)
  }
})
